export default __webpack_public_path__ + "static/media/pending.71b8e568.svg";